import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Radio } from 'antd';
import Table, { alphanumericSorter } from '../../../../common/components/Table';
import { setAdminAgency } from '../../../userAuth/store/slice';
import { resetConditionalPriority } from '../../../featurePersistence/store/slice';
import { IS_MIO_APP } from '../../../../common/constants/environment';

const AgencyTableForRegion = ({
  loading,
  agencies,
  selected,
  onSelectedChange,
}) => {
  const dispatch = useDispatch();

  const handleRadioClick = (key) => {
    const selectedKey = selected.includes(key) ? [] : [key];
    onSelectedChange(selectedKey);
  };

  const columns = [
    {
      className: 'ant-table-selection-col ant-table-before',
      render: (record) => (
        <Radio
          checked={selected[0] === record.id}
          onClick={() => handleRadioClick(record.id)}
        />
      ),
    },
    {
      dataIndex: 'name',
      key: 'name',
      title: 'Name',
      render: (_text, record) => {
        if (IS_MIO_APP) return record.name;

        const handleClick = () => {
          dispatch(
            setAdminAgency({
              agencyId: record.id,
            })
          );
          dispatch(resetConditionalPriority());
        };
        return (
          <Link
            to={`/config/agency-settings`}
            onClick={handleClick}
            className="btn-analytics"
            key={record.name}
          >
            {record.name}
          </Link>
        );
      },
      onFilter: (value, record) =>
        record.name
          ? record.name.toString().toLowerCase().includes(value.toLowerCase())
          : '',
      defaultSortOrder: 'ascend',
      sorter: alphanumericSorter('name'),
    },
    {
      dataIndex: 'description',
      key: 'description',
      title: 'Description',
    },
    {
      dataIndex: 'city',
      key: 'city',
      title: 'City',
      sorter: alphanumericSorter('city'),
    },
    {
      dataIndex: 'state',
      key: 'state',
      title: 'State',
      sorter: alphanumericSorter('state'),
    },
    {
      dataIndex: 'timezone',
      key: 'timezone',
      title: 'Time Zone',
    },
    {
      dataIndex: 'agencyCode',
      key: 'agencyCode',
      title: 'Agency Code',
      sorter: alphanumericSorter('agencyCode'),
    },
    {
      dataIndex: 'priority',
      key: 'priority',
      title: 'Priority',
      sorter: alphanumericSorter('priority'),
    },
    {
      dataIndex: 'cmsId',
      key: 'cmsId',
      title: 'CMS ID',
    },
  ];

  return (
    <section style={{ overflowX: 'scroll' }}>
      {!loading && (!agencies || agencies.length === 0) ? (
        <p>No associated agency</p>
      ) : (
        <Table
          rowKey="id"
          pagination={true}
          isLoading={loading}
          columns={columns}
          dataSource={agencies}
        />
      )}
    </section>
  );
};

export default AgencyTableForRegion;
